import { TruckSize } from '../../../../../common/constants/truck-size';
import { TruckStatus, UliActivityType, UliOrigin, UliStatus } from '../../../../../common/constants/uli';
import { NfStatus } from '../../nota-fiscal/models/nf-status.enum';
import { ListServerPaginationStateModel } from '../../../../../common';
import { Region } from '../../transport/constants/transport-list.constant';
import { LocalDate, LocalDateRangeModel } from '../../../../models/local-date.model';

export enum LoadStatusSize {
  Small = 'small',
  Large = 'large',
}

export interface AllocationViewUliParty {
  extId: string;
  name: string;
}

export interface AllocationViewUliLoadStatusModel {
  open: number;
  prepared: number;
  shipped: number;
}

export interface AllocationViewUliLoadProgressModel {
  open: number;
  loaded: number;
}

export interface AllocationViewUliErpInformationModel {
  loadProgress: AllocationViewUliLoadProgressModel;
  loadStatus: AllocationViewUliLoadStatusModel;
  confirmationPending: boolean;
  sapClientId: string;
  sapTransportationPlanningPoint: string;
}

export class AllocationViewUli {
  carrierId: string;
  carrierName: string;
  carrierNumber: string;
  freeTextCarrierName: string;
  allocatedCompartmentId: number;
  allocatedCompartmentName: string;
  compartmentId: number;
  compartmentName: string;
  dangerousGoods: boolean;
  dockId: number;
  dockName: string;
  hubId: number;
  hubName: string;
  leadUli: boolean;
  loadNumber: string;
  erpInformation: AllocationViewUliErpInformationModel;
  registrationId: number;
  parties: AllocationViewUliParty[];
  region: Region;
  status: UliStatus;
  slotId: number;
  timeSlot: LocalDateRangeModel;
  trailerPlate: string;
  trailerPlateCountry: string;
  truckId: number;
  truckPlate: string;
  truckPlateCountry: string;
  truckStatus: TruckStatus;
  truckStatusDate: LocalDate;
  truckSize: TruckSize;
  type: UliActivityType;
  uli: string;
  uliOrigin: UliOrigin;
  uliStatus: TruckStatus; // TODO: will be changed on the back-end soon (new separate status set for ULI)
  uliStatusDate: LocalDate;
  ulisInSlot: number;
  ulisInTruck: number;
  ruleId: number;
  ruleName: string;
  numberOfHu: string;
  highlightRow: boolean;
  equipmentTypes: string[];
  parkingSpaceId: string;
  prebookingNumber: string;
  nfStatus: NfStatus | null;

  constructor(params?: AllocationViewUli) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export type AllocationViewListResponse = ListServerPaginationStateModel<AllocationViewUli>;

export interface AllocationViewTimelineRowModel {
  uli: string;
  type: UliActivityType;
  compartmentId: number;
  top: boolean;
  index: number;
}

export class DriverViewList {
  registeredWebUliAllocationViews: AllocationViewUli[];
  calledToDockWebUliAllocationViews: AllocationViewUli[];
}
